/* GENERATED FILE */
import type { ReactElement } from "react";
import { Fragment } from "react";
import type { IconVariant } from "../lib";

export default new Map<IconVariant, ReactElement>([
	[
		"duocolor",
		<Fragment key={"duocolor"}>
			<path
				opacity="0.4"
				d="M10 20H15C18.5265 20 21.4439 17.3923 21.9291 14C21.9758 13.6734 22 13.3395 22 13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
			<path
				d="M2 6H15C18.866 6 22 9.13401 22 13C22 13.3395 21.9758 13.6734 21.9291 14M2 6L6 2M2 6L6 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"duotone",
		<Fragment key={"duotone"}>
			<path
				d="M2 6H15C18.866 6 22 9.13401 22 13V13C22 16.866 18.866 20 15 20H10M2 6L6 2M2 6L6 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"filled",
		<Fragment key={"filled"}>
			<path
				d="M2 6H15C18.866 6 22 9.13401 22 13V13C22 16.866 18.866 20 15 20H10M2 6L6 2M2 6L6 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"gestalt",
		<Fragment key={"gestalt"}>
			<path
				d="M2 6L6 2M2 6L6 10M2 6H9M10 20H15C18.866 20 22 16.866 22 13V13C22 9.13401 18.866 6 15 6H13.5H13"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"line",
		<Fragment key={"line"}>
			<path
				d="M2 6H15C18.866 6 22 9.13401 22 13V13C22 16.866 18.866 20 15 20H10M2 6L6 2M2 6L6 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
	[
		"mono",
		<Fragment key={"mono"}>
			<path
				d="M2 6H15C18.866 6 22 9.13401 22 13V13C22 16.866 18.866 20 15 20H10M2 6L6 2M2 6L6 10"
				stroke="currentColor"
				strokeWidth="1.5"
				strokeLinecap="round"
				strokeLinejoin="round"
			/>
		</Fragment>,
	],
]);
